export { getReparentTMPWarningFlag } from './view';
